import { applyMiddleware, compose, createStore } from 'redux'
import rootReducer from './reducers/rootReducer'
import middleware from './middleware'
import applyDevtoolExtension from './redux-devtools-extension'
import { initDispatch, routerEnhancer } from './router/router'
import { loadState } from '../utils/localStorage'

const persistedState = loadState()

const composeEnhancers = compose(
    routerEnhancer,
    applyMiddleware(...middleware),
    applyDevtoolExtension(),
)

const configureStore = () => {
    const store = createStore(rootReducer, persistedState, composeEnhancers)

    initDispatch()

    return store
}

export default configureStore
